import React from 'react'
import PropTypes from 'prop-types'
import getLabels from '../../utils/getLabels'

const Confirmation = ({ classes, onCancel, onConfirm, dataElement }) => {
  return (
    <span>
      <span
        className={classes.checkedInLink}
        onClick={() => onConfirm()}
        data-element={`${dataElement}-confirm`}
      >{`${getLabels('yes')}`}</span>
      <span className={classes.separator}>|</span>
      <span
        className={classes.checkedInLink}
        onClick={() => onCancel()}
        data-element={`${dataElement}-cancel`}
      >{`${getLabels('no')}`}</span>
    </span>
  )
}

Confirmation.propTypes = {
  classes: PropTypes.shape({
    checkedInLink: PropTypes.string,
    separator: PropTypes.string,
  }),
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default Confirmation
